import { useMemo } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';

import {
  CatalogSource,
  MapEditorCatalogElement,
  resolveCatalogElements,
} from './mapEditorCatalog';

export interface UseMapEditorCatalogResult {
  elements: MapEditorCatalogElement[];
  // 'build' means the streamed build shipped its own catalog through the GameCast metadata
  // provider; 'fallback' means it did not, and `elements` comes back empty. useCanUseMapEditor
  // reads this to decide whether the map has a map editor at all.
  source: CatalogSource;
}

export const useMapEditorCatalog = (): UseMapEditorCatalogResult => {
  const { currentRoom } = useMytaverseEvent();
  const layoutCatalog = currentRoom?.map?.layoutCatalog;

  return useMemo(() => resolveCatalogElements(layoutCatalog), [layoutCatalog]);
};
